const {h, render, Component} = require('preact')

class InvalidFAQErrorPage extends Component {
  constructor(props) {
    super(props);
  }

  getSupportBaseURL(){
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom && configFromDom.SUPPORTBASEURL)
      return configFromDom.SUPPORTBASEURL;
  }

  getFaqBaseURL(){
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom && configFromDom.FAQBASEURL)
      return configFromDom.FAQBASEURL;
  }

  render() {
    return (
      <div class="content" data-bhw="web2018_error_page">
        <div class="page-error error text-center">
          <h1>{I18n.translate('js.modules.support.oops')}</h1>
          <div class="error-content">
            <p>{I18n.translate('js.modules.web_2018.invalid_faq_error')}</p>
            <p>
              {I18n.translate('js.modules.web_2018.invalid_faq_error_youcan')}
              &nbsp;
              <a target="_top" class="error_reload" href={this.getFaqBaseURL()}>
                {I18n.translate('js.modules.web_2018.all_faqs')}
              </a>
              &nbsp;
              {I18n.translate('js.modules.support.or')}
              &nbsp;
              {I18n.translate('js.modules.web_2018.invalid_faq_error_visit')}
              &nbsp;
              <a target="_top" class="error_reload" href={this.getSupportBaseURL()}>
                {I18n.translate('js.modules.web_2018.helpcenter_title')}
              </a>
              &nbsp;
              {I18n.translate('js.modules.web_2018.invalid_faq_error_any_other')}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = InvalidFAQErrorPage;
